import { useMemo } from 'react';
import type { SecurityTarget } from '../../auth/Security';
import type { SecuredActionType } from '../ActionType';

export type SecuredActionWithSecurityTarget = {
    action: SecuredActionType;
    securityTarget: SecurityTarget;
};

function makeSecuredActionSecurityTarget(action: SecuredActionType): SecurityTarget {
    const securityTarget: SecurityTarget = {
        entityName: action.entityName,
        entitySecurity: action.entitySecurity,
        featureName: action.featureName
    };

    return securityTarget;
}

export function useSecuredActionsWithSecurityTargets(
    securedActions: SecuredActionType[]
): SecuredActionWithSecurityTarget[] {
    return useMemo(
        () =>
            securedActions.map((action) => ({
                action,
                securityTarget: makeSecuredActionSecurityTarget(action)
            })),
        [securedActions]
    );
}
